import { SVGProps } from "react";

export function PaymentIcon({
  size = 24,
  color = "currentColor",
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props as any)}
    >
      <path
        d="M5.25 5C4.38805 5 3.5614 5.34241 2.9519 5.9519C2.34241 6.5614 2 7.38805 2 8.25V9.5H22V8.25C22 7.8232 21.9159 7.40059 21.7526 7.00628C21.5893 6.61197 21.3499 6.25369 21.0481 5.9519C20.7463 5.65011 20.388 5.41072 19.9937 5.24739C19.5994 5.08406 19.1768 5 18.75 5H5.25ZM22 11H2V15.75C2 16.612 2.34241 17.4386 2.9519 18.0481C3.5614 18.6576 4.38805 19 5.25 19H18.75C19.1768 19 19.5994 18.9159 19.9937 18.7526C20.388 18.5893 20.7463 18.3499 21.0481 18.0481C21.3499 17.7463 21.5893 17.388 21.7526 16.9937C21.9159 16.5994 22 16.1768 22 15.75V11ZM15.75 14.5H18.25C18.4489 14.5 18.6397 14.579 18.7803 14.7197C18.921 14.8603 19 15.0511 19 15.25C19 15.4489 18.921 15.6397 18.7803 15.7803C18.6397 15.921 18.4489 16 18.25 16H15.75C15.5511 16 15.3603 15.921 15.2197 15.7803C15.079 15.6397 15 15.4489 15 15.25C15 15.0511 15.079 14.8603 15.2197 14.7197C15.3603 14.579 15.5511 14.5 15.75 14.5Z"
        fill={color}
      />
    </svg>
  );
}
